/**
 * @title edd.js: Feature level module
 * @description A collection of edd functions used
 * application wide. This module should contain
 * edd utility code.
 */

define([], function() {
    var EDD ={

		/**
	     * Message Types for Delivery Services
	     */
		INCLUDED_MESSAGE_TYPE:"Included",
		EXCLUDED_MESSAGE_TYPE:"Excluded",
		WARNING_MESSAGE_TYPE:"Warning",
		INFORMATIONAL_MESSAGE_TYPE:"Informational",
    	
		/**
          * Method to invoke delivery API service
        **/
		invokeDeliveryServices: function(deliveryServicesRequestMap,jsonDataForDBSave) {
	    	var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
	    	var deliveryServicesConnectionTime = $('#connectionTimeOutForEDD').val();
			var costcoEnv = COSTCO.Product.validateCostcoEnv();
			var deliveryServicesResponseMap = new Map();
			var responseCount = 0;
			
			const timeOutController = COSTCO.util.getTimeoutController();
			 for (var orderItem of deliveryServicesRequestMap.keys()) {
				 
				 installationUri = deliveryServicesRequestMap.get(orderItem);
				 
				 timeOutController(deliveryServicesConnectionTime, fetch(installationUri, {
						method: 'GET',
						headers: {
	                      "costco.env": costcoEnv,
	                      "client-identifier" : clientIdentifier
						 }
	           }))
			   .then(response => response.json())
			     .then(jsonResponse => {
			    	 
			    	 responseCount++;
			    	 if (jsonResponse.services !== undefined && jsonResponse.services.length > 0){
			    		 
                         if (undefined !== jsonResponse.orderItemId){
                        	 deliveryServicesResponseMap.set(jsonResponse.orderItemId, jsonResponse.services);
                         }
                     }

			    	 if (deliveryServicesRequestMap.size == responseCount) {
                         if (deliveryServicesResponseMap.size > 0) {
                        	 eddInstallationServicesJSON = jsonResponse.services;
                         }
                     }
			    	 
		        }).catch(err => {
                    responseCount++;
                    
                    if (deliveryServicesRequestMap.size == responseCount) {
                        if (deliveryServicesResponseMap.size > 0) {
                        	 eddInstallationServicesJSON = jsonResponse.services;
                        }                   
                    }
                });
			 }
		    
		 },
		 
		 /**
	       * Method populate installation services in cart and checkout review pages
	       */
		 populateDeliveryServices: function(deliveryServicesResponseMap) {

	          for (var orderItemId of deliveryServicesResponseMap.keys()) {
	              let eddInstallationServicesContainer = '';
	              
	              eddInstallationServicesContainer = COSTCO.EDD.buildHTMLforDeliveryServices(deliveryServicesResponseMap.get(orderItemId));
	
	              if (null !== document.getElementById('cart_installation_services_' + orderItemId)){
	            	  document.getElementById('cart_installation_services_' + orderItemId).innerHTML = "";
	            	  $('#cart_installation_services_' + orderItemId).removeClass('hidden');
		              $('#cart_installation_services_' + orderItemId).append(eddInstallationServicesContainer.replace('parts-icon-margin',""));
	              }
	          }
	      },
	      
	      buildHTMLforDeliveryServices: function(eddInstallationServicesJSON) {
		    let eddDeliveryServicesHTML = '';
	
		    let eddDeliveryWarningServices = '';
		    let eddDeliveryIncludedServices = '';
		    let eddDeliveryExcludedServices = '';
		    let eddDeliveryInformationServices = '';
		    let eddDeliveryServicesContainerHTML = '';
	          
	          $.each(eddInstallationServicesJSON, function(index, serviceJson) {
	          	  let descriptionText = [serviceJson.message];
	          	  if (typeof descriptionText !== 'undefined' && descriptionText !== null && descriptionText !== ''){
	          		  if (serviceJson.messageType === COSTCO.EDD.WARNING_MESSAGE_TYPE) {
	          			  eddDeliveryWarningServices += COSTCO.util.tmpl('templ_edd_delivery_services_row_warning', {'description' : descriptionText});
	          		  }
	          		  if (serviceJson.messageType === COSTCO.EDD.INCLUDED_MESSAGE_TYPE) {
	          			  eddDeliveryIncludedServices += COSTCO.util.tmpl('templ_edd_installation_services_row', {'description' : descriptionText});
	          		  }
	          		  if (serviceJson.messageType === COSTCO.EDD.EXCLUDED_MESSAGE_TYPE) {
	          			  eddDeliveryExcludedServices += COSTCO.util.tmpl('templ_edd_installation_services_row_not_included', {'description' : descriptionText});
	          		  }
	          		  if (serviceJson.messageType === COSTCO.EDD.INFORMATIONAL_MESSAGE_TYPE) {			  
	          			  eddDeliveryInformationServices += COSTCO.util.tmpl('templ_edd_delivery_services_row_informational', {'description' : descriptionText});
	          		  }	  
	            }
	            
	          });
	          
	          if (eddDeliveryWarningServices !=='') {
	        	  eddDeliveryServicesHTML += eddDeliveryWarningServices;
	  		}
	          
	          if (eddDeliveryIncludedServices !== '') {
	        	  eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
	              	sectionTitle: messages.DELIVERY_SERVICES_INCLUDED_TITLE,
	              	services: eddDeliveryIncludedServices
	          	});
	          }
	          
	      	 if (eddDeliveryExcludedServices !== '') {
	      		 eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
	               	sectionTitle: messages.DELIVERY_SERVICES_EXCLUDED_TITLE,
	               	services: eddDeliveryExcludedServices
	           	});
	      	 }
	       	if (eddDeliveryInformationServices !== '') {
	       		eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
	               	sectionTitle: messages.DELIVERY_SERVICES_INFORMATIONAL_TITLE,
	               	services: eddDeliveryInformationServices
	           	});
	       	}
	       	
	       	if (eddDeliveryServicesHTML.length) {
	       		eddDeliveryServicesContainerHTML = COSTCO.util.tmpl('templ_edd_delivery_services', {
	       			title: messages.EDD_DELIVERY_SERVICES_CHECKOUT_SUBTITLE,
		        	sections: eddDeliveryServicesHTML
		        });
	       	}
	       	
	    	return eddDeliveryServicesContainerHTML;
	      }
	      
    }


  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.EDD = EDD;
  return EDD;

});



// WEBPACK FOOTER //
// ./js/global/edd.js